import type { ReactNode } from 'react'

type TemplateOptionProps = {
  active: boolean
  onSelect: () => void
  title: string
  description: string
  illustration: ReactNode
}

export function TemplateOption({ active, onSelect, title, description, illustration }: TemplateOptionProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`flex flex-col gap-3 rounded-lg border bg-card p-4 text-left transition ${
        active ? 'border-primary ring-2 ring-primary/30' : 'border-black/10 hover:border-primary/40'
      }`}
    >
      <div className="flex h-28 items-center justify-center rounded-md bg-muted/40">
        {illustration}
      </div>
      <div>
        <div className="text-sm font-medium">{title}</div>
        <div className="mt-1 text-xs text-muted-foreground">{description}</div>
      </div>
    </button>
  )
}

export function ClassicIllustration() {
  return (
    <svg width="120" height="84" viewBox="0 0 120 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="116" height="28" rx="3" fill="currentColor" className="text-primary/30" />
      <rect x="2" y="36" width="72" height="6" rx="1.5" fill="currentColor" className="text-foreground/50" />
      <rect x="2" y="46" width="58" height="4" rx="1.5" fill="currentColor" className="text-foreground/25" />
      <rect x="2" y="54" width="66" height="4" rx="1.5" fill="currentColor" className="text-foreground/25" />
      <rect x="2" y="62" width="40" height="4" rx="1.5" fill="currentColor" className="text-foreground/25" />
      <rect x="82" y="36" width="36" height="46" rx="3" fill="currentColor" className="text-secondary/40" />
    </svg>
  )
}

export function GalleryIllustration() {
  return (
    <svg width="120" height="84" viewBox="0 0 120 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="52" height="48" rx="3" fill="currentColor" className="text-primary/30" />
      <rect x="60" y="4" width="58" height="8" rx="1.5" fill="currentColor" className="text-foreground/60" />
      <rect x="60" y="18" width="40" height="4" rx="1.5" fill="currentColor" className="text-foreground/30" />
      <rect x="60" y="26" width="46" height="4" rx="1.5" fill="currentColor" className="text-foreground/25" />
      <rect x="60" y="38" width="34" height="8" rx="2" fill="currentColor" className="text-secondary/60" />
      <rect x="2" y="58" width="50" height="4" rx="1.5" fill="currentColor" className="text-foreground/30" />
      <rect x="2" y="66" width="38" height="4" rx="1.5" fill="currentColor" className="text-foreground/25" />
      <rect x="2" y="74" width="42" height="4" rx="1.5" fill="currentColor" className="text-foreground/25" />
      <rect x="66" y="58" width="52" height="20" rx="3" fill="currentColor" className="text-secondary/40" />
    </svg>
  )
}
